import DoodleRay8 from "../assets/doodle-ray-8.svg?react"
import styles from "./SafeExitButton.module.scss"

export function SafeExitButton() {
  return (
    <div className={styles.wrapper} data-safe-exit>
      <button
        className={styles.button}
        onClick={() => window.location.replace("https://www.google.com/")}
        aria-label="Safe Exit, press anytime you feel unsafe."
      >
        Safe Exit
        <DoodleRay8 className={styles.icon} aria-hidden={true} />
      </button>
      {/* Folded into the button's accessible name above, so hidden from AT to
          avoid a duplicate read (a11y annotations). */}
      <p className={styles.support} aria-hidden={true}>
        Press anytime you feel unsafe.
      </p>
    </div>
  )
}
